// import { useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FormBeketPassengersValues } from 'entities/beket/models/form-passengers/model'
// import beketListTicketsStore from 'entities/beket/models/ticket/beket-list-tickets/beket-list-tickets-store'
import { FormHeader } from 'entities/beket/ui/order-form/ui/form-header'

import {
  TYPE_AGE_BEKET, // , TariffBeket, TariffBeketList
} from 'shared/constants'
// import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
// import { dateFormat } from 'shared/lib/dateFormat'
// import citizenshipStore from 'shared/store/citizenship-store'
// import { DatePickerWithLabel } from 'shared/ui/date-picker-label'
import { InputWithLabel } from 'shared/ui/input-label'
import { Paper } from 'shared/ui/paper'
import { Option } from 'shared/ui/select'
import { SelectWithLabel } from 'shared/ui/select-label'

import s from './styles.module.scss'

interface Props {
  isAbroad?: boolean
  isChild?: boolean
  currentIsChild?: boolean
  index: number
  typeAge: TYPE_AGE_BEKET
  passengerCount: number
  citizenship?: Option[]
}

export const BeketOrderForm = ({
  index,
  typeAge,
  citizenship,
  passengerCount,
  isChild = false,
  isAbroad = false,
}: Props) => {
  const { t } = useTranslation()

  // const [isShowChildContent, setIsShowChildContent] = useState(currentIsChild)

  // const departureDate = beketListTicketsStore.selectedTicket?.departure_datetime

  const {
    control,
    formState: { errors },
  } = useFormContext<FormBeketPassengersValues>()

  // const validateDate = (value: never) => {
  //   if (!departureDate) {
  //     return
  //   }

  //   const date = new Date(value)
  //   const departure = new Date(departureDate)

  //   const tenYearsAgo = new Date(departure)
  //   tenYearsAgo.setFullYear(tenYearsAgo.getFullYear() - 10)

  //   return date >= tenYearsAgo || t('beket.child_validation')
  // }

  // const onChangeTariff = (option: Option) => {
  //   setIsShowChildContent(option?.value === TariffBeket.child.key)
  // }

  const keyPassenger = `${typeAge}.${index}` as const
  return (
    <Paper padding={[20, 16]}>
      <FormHeader
        passengerCount={passengerCount}
        formInfo={{
          index,
          typeAge,
          isChild,
          isAbroad,
        }}
      />

      <div className={s.form}>
        <Controller
          control={control}
          name={`${keyPassenger}.lastName`}
          rules={{ required: true, minLength: 2, maxLength: 30 }}
          render={({ field }) => (
            <InputWithLabel
              label={t('last_name')}
              ref={field.ref}
              value={field?.value}
              error={errors?.[typeAge]?.[index]?.lastName}
              onChange={(event) => field?.onChange(event.currentTarget.value)}
            />
          )}
        />

        <Controller
          control={control}
          name={`${keyPassenger}.firstName`}
          rules={{ required: true, minLength: 2, maxLength: 30 }}
          render={({ field }) => (
            <InputWithLabel
              label={t('first_name')}
              ref={field.ref}
              value={field?.value}
              error={errors?.[typeAge]?.[index]?.firstName}
              onChange={(event) => field?.onChange(event.currentTarget.value)}
            />
          )}
        />

        {isAbroad && (
          <>
            <Controller
              name={`${keyPassenger}.citizenship`}
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <SelectWithLabel
                  {...field}
                  ref={field?.ref}
                  key={field.value}
                  value={field.value}
                  options={citizenship}
                  label={t('citizenship')}
                  error={errors?.[typeAge]?.[index]?.citizenship}
                  onChange={(option) => field.onChange(option.value)}
                />
              )}
            />

            <Controller
              control={control}
              name={`${keyPassenger}.serialDocuments`}
              rules={{ required: true, minLength: 2, maxLength: 30 }}
              render={({ field }) => (
                <InputWithLabel
                  label={t('purchase_page.serial_number_pass')}
                  ref={field.ref}
                  value={field?.value}
                  onChange={(event) =>
                    field?.onChange(event.currentTarget.value)
                  }
                  error={errors?.[typeAge]?.[index]?.serialDocuments}
                />
              )}
            />
          </>
        )}

        {/* {isShowChildContent && (
          <Controller
            name={`${keyPassenger}.dateOfBirth`}
            control={control}
            rules={{
              required: true,
              validate: (value) => validateDate(value),
            }}
            render={({ field }) => (
              <DatePickerWithLabel
                key={field.value}
                label={t('birth_day')}
                {...field}
                value={field.value ? new Date(field.value) : undefined}
                onChange={(date) => {
                  field.onChange(
                    dateFormat(date, DATE_FORMAT_LIST.YEAR_FULL_DATE),
                  )
                }}
                error={errors?.[typeAge]?.[index]?.dateOfBirth}
              />
            )}
          />
        )} */}

        {/* {isChild && (
          <Controller
            name={`${keyPassenger}.tariff`}
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <SelectWithLabel
                options={TariffBeketList}
                {...field}
                ref={field?.ref}
                value={field.value}
                label={t('beket.tariff')}
                onChange={(option) => {
                  onChangeTariff(option)
                  field.onChange(option.value)
                }}
                error={errors?.[typeAge]?.[index]?.tariff}
              />
            )}
          />
        )} */}
      </div>
    </Paper>
  )
}
